import api from './api';
import { StandSaleContract } from '../types';

interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  message: string;
  subject: string;
  files?: File[];
}

/**
 * Sends form data to a specified endpoint, handling both regular data and data with file attachments
 * @param endpoint The API endpoint
 * @param data The contact form data (potentially with files)
 * @returns Promise with the response
 */
export const sendFormData = async (endpoint: string, data: ContactFormData) => {
  try {
    const formDataObj = new FormData();

    formDataObj.append('name', data.name);
    formDataObj.append('email', data.email);
    if (data.phone) formDataObj.append('phone', data.phone);
    formDataObj.append('message', data.message);
    formDataObj.append('subject', data.subject);

    if (data.files && data.files.length > 0) {
      data.files.forEach((file) => {
        formDataObj.append('files', file);
      });
    }

    const response = await api.post(endpoint, formDataObj, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error(`Error sending data to ${endpoint}:`, error);
    throw error;
  }
};

/**
 * Sends a collection purchase inquiry to the specified email
 * @param formData The contact form data (potentially with files)
 * @returns Promise with the response
 */
export const sendCollectionInquiry = async (formData: ContactFormData) => {
  return sendFormData('/contact/collections', formData);
};

/**
 * Sends a general contact form submission
 * @param formData The contact form data
 * @returns Promise with the response
 */
export const sendContactForm = async (formData: ContactFormData) => {
  return sendFormData('/contact', formData);
};

/**
 * Sends the stand sale form; the backend emails a pre-filled purchase contract to us
 * @param contract The seller's details and what they are selling
 * @returns Promise with the response
 */
export const sendStandSaleContract = async (contract: StandSaleContract) => {
  const response = await api.post('/contact/stand-sale', contract);
  return response.data;
};
